
import React from "react";
import { Info } from "lucide-react";

const FormOfAddressNote = () => {
  return (
    <section className="py-6 bg-white">
      <div className="container">
        <div className="max-w-3xl mx-auto p-5 bg-joerg-50 rounded-xl border border-joerg-100 shadow-sm">
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 mt-1">
              <div className="bg-primary/10 p-2 rounded-full">
                <Info className="h-5 w-5 text-primary" />
              </div>
            </div>
            <div>
              <h3 className="text-lg font-medium mb-2 text-joerg-800">Persönliche Ansprache im Coaching</h3>
              <p className="text-joerg-600">
                Im Coaching-Kontext verwende ich bewusst die persönlichere Du-Form, 
                da sie einen offenen und vertrauensvollen Austausch fördert. 
                Selbstverständlich respektiere ich Ihre Präferenz und biete auf Wunsch 
                auch die formelle Ansprache (Sie-Form) an. In Ihrem kostenlosen 
                Erstgespräch klären wir gemeinsam, welche Ansprache für Sie angenehmer ist.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FormOfAddressNote;
